import React from 'react';
import Layout from '../components/Layout';

const ProximamentePage = ({ titulo, descripcion }) => (
  <Layout>
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      minHeight: '60vh', gap: 16,
    }}>
      <div style={{
        width: 64, height: 64, borderRadius: 16,
        background: 'rgba(96,165,250,0.1)', border: '1px solid rgba(96,165,250,0.25)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="#60a5fa" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: '#e2e8f0', marginBottom: 6 }}>{titulo}</div>
        <div style={{ fontSize: 13, color: '#64748b' }}>
          {descripcion || 'Este módulo está en desarrollo. Estará disponible próximamente.'}
        </div>
      </div>
    </div>
  </Layout>
);

export default ProximamentePage;
